﻿﻿﻿
<iframe title="EOX NI Ops Direct Report"
        style="height: 85vh; display: block; width: -webkit-fill-available"
        src="https://app.powerbi.com/reportEmbed?reportId=f2639f82-d33e-4ae7-a340-6aba0a76c13e&appId=488c3f6f-3ec7-4a35-85ba-49164172d526&autoAuth=true&ctid=84d9a216-e285-4aac-b163-0dfd0c074546"
        frameborder="0"
        allowFullScreen="true">
</iframe>

